<template>
    <v-container fluid class="hkiarace-view pa-0">
        <router-view/>
    </v-container>
</template>

<script>
    export default {
        name: 'Hkiarace'
    }
</script>
<style lang="less">
    .hkiarace-view {
        height: calc(100% - 110px);
    }
</style>
